import { render } from "./IdCardPage.vue?vue&type=template&id=d73f8c50&scoped=true"
import script from "./IdCardPage.vue?vue&type=script&lang=js"
export * from "./IdCardPage.vue?vue&type=script&lang=js"

import "./IdCardPage.vue?vue&type=style&index=0&id=d73f8c50&scoped=true&lang=css"
import "./IdCardPage.vue?vue&type=style&index=1&id=d73f8c50&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d73f8c50"]])

export default __exports__